export const uniqId = (prefix?: string): string => {
  return `${prefix}${Date.now().toString(36)}${Math.random().toString(36)}`;
};
